/** Permission keys (PLAN Appendix A). The owner holds "*". */
export const PAGE_PERMS = [
  'p.today',
  'p.calendar',
  'p.walkin',
  'p.checkin',
  'p.checkout',
  'p.overview',
  'p.finance',
  'p.reports',
  'p.vouchers',
  'p.fleet',
  'p.team',
  'p.pricing',
  'p.content',
] as const;

export const ACTION_PERMS = [
  'f.booking.edit',
  'f.booking.credit',
  'f.booking.cancel',
  'f.price.view',
  'f.invoice.issue',
  'f.reports.export',
  'f.credits.assign',
  'f.documents.view',
  'f.booking.reassign',
  'f.payments.record',
  'f.policy.override',
] as const;

export type PagePerm = (typeof PAGE_PERMS)[number];
export type ActionPerm = (typeof ACTION_PERMS)[number];
export type Perm = PagePerm | ActionPerm;

/** True when the permission list grants `perm` ("*" grants everything). */
export function hasPerm(perms: readonly string[] | null | undefined, perm: Perm): boolean {
  if (!perms) return false;
  return perms.includes('*') || perms.includes(perm);
}

/** True when any of the permissions is granted. */
export function hasAny(perms: readonly string[] | null | undefined, list: readonly Perm[]): boolean {
  return list.some((p) => hasPerm(perms, p));
}
